module.exports = __webpack_public_path__ + "img/61.9b8ca343.jpg";